// Ensure Node-like globals exist in the browser for certain packages (e.g., buffer, amazon-cognito-identity-js)

// Use ESM import for Buffer so Vite can pre-bundle properly
import { Buffer } from 'buffer';

// global
if (typeof window !== 'undefined' && typeof window.global === 'undefined') {
  window.global = window; // map global to window for browser
}

// Buffer
if (typeof window !== 'undefined' && typeof window.Buffer === 'undefined') {
  window.Buffer = Buffer;
}

// Minimal process shim; actual env is managed by Vite plugins
if (typeof window !== 'undefined') {
  window.process = window.process || { env: {} };
}
